// extracted by mini-css-extract-plugin
export default {"layout":"layout--rDGjt","callingScreen":"callingScreen--zsK5O","animation-bzdot9":"animation-bzdot9--NPmGZ"};